import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../common/themes/themes';
import { useAppSelector } from '../../infra/hooks';
import CustomAddButton from '../../common/components/CustomAddButton/CustomAddButton';
import CustomModal from '../../common/Modals/CustomModal/CustomModal';
import ModalHeader from '../../common/Modals/CustomModal/ModalHeader';
import Compdirection from '../../common/themes/CompDirection';
import ModalFooter from '../../common/Modals/CustomModal/ModalFooter';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslate } from '../../hooks';
import { arabicDataGrid } from '../../common/helper';
import CustomTextField from '../../common/components/CustomTextField/CustomTextField';
import DropAndSelect from '../../common/components/DropAndSelect/DropAndSelect';
import { suggestionService } from '../../api/services/suggestionservice';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { colors } from '../../helpers';
import ImageModelView from '../../common/components/ImageViewer/ImageModelView';
import GetPayHistoryActionBox from '../../common/components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import SearchComponent from '../../common/components/SearchComponent';
import CustomAutoComplete from '../../common/components/CustomAutoComplete/CustomAutoComplete';
import CustomStepper_sugg from '../../common/Modals/Stepper/CustomStepper_sugg';
interface Propval {
  trans: any;
  i18n: any;
}
const SuggestionPresenter = ({ trans, i18n }: Propval) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { isRTL } = useTranslate();
  const [openModel, closeModal] = useState<boolean>(false);
  const [openEditModel, closeEditModal] = useState<boolean>(false);
  const [editdata, setEditData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [toEmpId, setToEmpId] = useState('');
  const selector = useAppSelector((state) => state);
  const [openStepper, closeStepper] = useState(false);
  const [sugg_status, setsugg_status] = useState([]);

  const [editdataID, setEditdataID] = useState('');

  const [suggestionAttachmentFile, setSuggestionAttachmentFile] =
    useState<any>('');
  const [suggestionAttachmentFilePath, setSuggestionAttachmentFilePath] =
    useState('');
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const [page, setPage] = useState(0);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [openViewFullPicModal, setOpenViewFullPicModal] =
    useState<boolean>(false);
  const [suggestionList, setSuggestionList] = useState([]);
  const [attachmentUrl, setAttachmenUrl] = useState('');

  const [debounceTerm, setDebounceTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const [suggestionEmpList, setSuggestionempList] = useState<any>([]);
  const [e_name, sete_name] = useState('');
  const [e_nameId, sete_nameId] = useState('');
  const companyId = selector.authSlice.company_id;

  useEffect(() => {
    getsuggemplist();
  }, []);

  const getsuggemplist = async () => {
    suggestionService
      .suggestionRoleEmpList(selector.authSlice.company_id)
      .then((response) => {
        setSuggestionempList(response?.data);
      });
  };
  const callSuggestionStatusDetails = (suggestionrefId: any) => {
    const companyID = companyId;
    suggestionService
      .getSuggestionStatusDetails(suggestionrefId, companyID)
      .then((res: any) => {
        setsugg_status(res);
      });
  };
  const getSuggestionData = async () => {
    suggestionService
      .getSuggestionList(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        page + 1,
        rowPerPage,
        searchTerm,
      )
      .then((res) => {
        setSuggestionList(res?.data?.data);
        setTotalCount(res?.data?.total_count);
      });
  };
  useEffect(() => {
    getSuggestionData();
  }, [page, rowPerPage, searchTerm]);

  useEffect(() => {
    setPage(0);
    const timer = setTimeout(() => {
      setSearchTerm(debounceTerm);
    }, 1000);
    return () => clearTimeout(timer);
  }, [debounceTerm]);

  useEffect(() => {
    if (suggestionEmpList?.length == 1) {
      sete_nameId(suggestionEmpList[0]?.empid);
    }
  }, [suggestionEmpList]);

  const clearState = () => {
    setTitle('');
    setDescription('');
    setSuggestionAttachmentFile('');
    setSuggestionAttachmentFilePath('');
    sete_name('');
    sete_nameId('');
    setToEmpId('');
  };
  const handleupdate = () => {
    if (toEmpId == '') {
      toast.error('Select Employee');
      return false;
    }
    if ([title, description].some((field) => field.trim() === '')) {
      toast.error(trans('Please fill all fields'));
    } else {
      const formData: any = new FormData();
      formData.append('sugg_id', editdataID);
      formData.append('emp_id', selector.authSlice.emp_id);
      formData.append('company_id', selector.authSlice.company_id);
      formData.append('sug_title', title);
      formData.append('sug_des', description);
      formData.append('to_emp_id', e_nameId);
      formData.append('locale', localStorage.getItem('emplang'));
      suggestionService
        .updateSuggestionbyEmp(formData)
        .then((res) => {
          clearState();
          toast.success(res?.message);
          getSuggestionData();
          closeEditModal(false);
        })
        .catch((err) => {
          console.log(err, 'errr');
          toast.error(
            err?.response?.data?.message || err?.response?.data?.data,
          );
          clearState();
          closeEditModal(false);
        });
    }
  };
  const handleSubmit = (data: any) => {
    if ([title, description].some((field) => field.trim() === '')) {
      toast.error(trans('Please fill all fields'));
    } else {
      const formData: any = new FormData();
      formData.append('emp_id', selector.authSlice.emp_id);
      formData.append('company_id', selector.authSlice.company_id);
      formData.append('sug_title', title);
      formData.append('sug_des', description);
      formData.append('to_emp_id', e_nameId);
      formData.append('locale', localStorage.getItem('emplang'));
      if (suggestionAttachmentFile)
        formData.append('attachment', suggestionAttachmentFile);

      suggestionService
        .createSuggestion(formData)
        .then((res) => {
          clearState();
          toast.success(res?.message);
          getSuggestionData();
          closeModal(false);
        })
        .catch((err) => {
          console.log(err, 'errr');
          toast.error(
            err?.response?.data?.message || err?.response?.data?.data,
          );
          clearState();
          closeModal(false);
        });
    }
  };

  const suggestionAttachmentUpload = (e: any) => {
    const _file = e.target.files[0];
    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      setSuggestionAttachmentFile(_file);
      setSuggestionAttachmentFilePath(image_as_base64);
    } else {
      setSuggestionAttachmentFile(_file);
      setSuggestionAttachmentFilePath('');
      setIsPDF(true);
      setPDFName(_file?.name);
    }
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (limit: number) => {
    setRowsPerPage(limit);
    setPage(0);
  };

  const handleEdit = (editdata: any) => {
    closeEditModal(true);
    //setEditData(editdata);
    setTitle(editdata?.title);
    setDescription(editdata?.description);
    setEditdataID(editdata?.editdataId);
  };

  const handleView = (attachment: any) => {
    setAttachmenUrl(attachment);
  };
  const handleEmplist = (emp__name: any) => {
    sete_nameId(emp__name.id);
    sete_name(emp__name.label);
    setToEmpId(emp__name.label);
    /* const filtered__suggestionEmpList = _.filter(
      suggestionEmpList,
      function (g: any) {
        return g.empname === emp__name;
      },
    );

    if (filtered__suggestionEmpList.length) {
      const gndr = filtered__suggestionEmpList[0];
      sete_nameId(gndr.empid);
      sete_name(emp__name);
      setToEmpId(emp__name);
    } */
  };

  const handleModel = (param: any) => {
    console.log(param);
    callSuggestionStatusDetails(param);
    closeStepper(true);
  };

  const tableColumns: any = [
    {
      field: 'title',
      headerName: trans('Title'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'description',
      headerName: trans('Description'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'suggestiontoemp',
      headerName: trans('Suggestion To'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'attachment',
      headerName: trans('Attachment'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenViewFullPicModal(true);
              handleView(params?.row?.attachment);
            }}
          />
        );
      },
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        switch (Number(params?.row?.status)) {
          case 0:
            return (
              <Typography
                style={{
                  color: 'brown',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#FFF8DC',
                }}
              >
                {trans('Pending')}
              </Typography>
            );

          case 1:
            return (
              <Typography
                style={{
                  color: colors.green,
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#d5fff6af',
                }}
              >
                {trans('Approved')}
              </Typography>
            );
          case 2:
            return (
              <Typography
                style={{
                  color: 'white',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#f1c40f',
                }}
              >
                {trans('Forwarded')}
              </Typography>
            );
          case 3:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#ffc0c767',
                }}
              >
                {trans('Rejected')}
              </Typography>
            );
          case 4:
            return (
              <Typography
                style={{
                  color: 'white',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#f1c40f',
                }}
              >
                {trans('Requested')}
              </Typography>
            );
          case 5:
            return (
              <Typography
                style={{
                  color: colors.green,
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#d5fff6af',
                }}
              >
                {trans('Updated')}
              </Typography>
            );
          default:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#fa8c9bf5',
                }}
              >
                {trans('Pending')}
              </Typography>
            );
        }
      },
    },
    {
      field: 'referenceId',
      headerName: trans('Action'),
      width: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <>
            {params?.row?.isEdit && (
              <Grid item xs={4}>
                <Box
                  style={{
                    border: '1px solid #E6E8EF',
                    color: '#21D8A5',
                    width: '1.8125em',
                    height: '1.8125em',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    borderRadius: '0.375em',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleEdit(params?.row)}
                >
                  <i className="las la-pencil-alt"></i>
                </Box>
              </Grid>
            )}

            <Grid item xs={4}>
              <Box
                style={{
                  border: '1px solid #E6E8EF',
                  color: themes.primary,
                  width: '1.8125em',
                  height: '1.8125em',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  borderRadius: '0.375em',
                  cursor: 'pointer',
                }}
                onClick={() => handleModel(params?.row?.referenceId)}
              >
                <i className="las la-info-circle"></i>
              </Box>
            </Grid>
          </>
        );
      },
    },
  ];

  const tableColumns_model: any = [
    {
      field: 'title',
      headerName: trans('Title'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'description',
      headerName: trans('Description'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'suggestionfromemp',
      headerName: trans('Suggestion from'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'suggestiontoemp',
      headerName: trans('Suggestion To'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'attachment',
      headerName: trans('Attachment'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <>
            {params?.row?.attachment && (
              <GetPayHistoryActionBox
                onView={() => {
                  setOpenViewFullPicModal(true);
                  handleView(params?.row?.attachment);
                }}
              />
            )}
          </>
        );
      },
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        switch (Number(params?.row?.status)) {
          case 0:
            return (
              <Typography
                style={{
                  color: 'brown',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#FFF8DC',
                }}
              >
                {trans('Pending')}
              </Typography>
            );

          case 1:
            return (
              <Typography
                style={{
                  color: colors.green,
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#d5fff6af',
                }}
              >
                {trans('Approved')}
              </Typography>
            );
          case 2:
            return (
              <Typography
                style={{
                  color: 'white',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#f1c40f',
                }}
              >
                {trans('Forwarded')}
              </Typography>
            );
          case 3:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#ffc0c767',
                }}
              >
                {trans('Rejected')}
              </Typography>
            );
          case 4:
            return (
              <Typography
                style={{
                  color: 'white',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#f1c40f',
                }}
              >
                {trans('Requested')}
              </Typography>
            );
          case 5:
            return (
              <Typography
                style={{
                  color: colors.green,
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#d5fff6af',
                }}
              >
                {trans('Updated')}
              </Typography>
            );
          default:
            return (
              <Typography
                style={{
                  color: '#FF5263',
                  fontSize: '12px',
                  padding: '0.25rem 0.5rem',
                  width: 'fit-content',
                  borderRadius: '0.375rem',
                  backgroundColor: '#fa8c9bf5',
                }}
              >
                {trans('Pending')}
              </Typography>
            );
        }
      },
    },
  ];

  const row_data: any = _.map(suggestionList, (list: any) => {
    return {
      id: list?.id,
      sugg_emp_id: list?.to_emp_id,
      title: list?.title,
      description: list?.description,
      suggestiontoemp: list?.tofirstname + ' ' + list?.tolastname,
      attachment: list?.attachement,
      status: list?.status,
      referenceId: list?.reference_id,
      toempId: list?.to_emp_id,
      isEdit: list?.isEdit,
      editdataId: list?.editdataId,
    };
  });
  const row_data_model: any = _.map(sugg_status, (list: any) => {
    return {
      id: list?.id,
      sugg_emp_id: list?.to_emp_id,
      title: list?.title,
      description: list?.description,
      suggestionfromemp: list?.fromempfistname + ' ' + list?.fromemplastname,
      suggestiontoemp: list?.toempfistname + ' ' + list?.toemplastname,
      attachment: list?.attachement,
      status: list?.status,
      referenceId: list?.reference_id,
      toempId: list?.to_emp_id,
      isEdit: list?.isEdit,
      editdataId: list?.editdataId,
    };
  });

  return (
    <Grid
      container
      style={{
        height: '100%',
        marginTop: '4em',
        width: '100vw',
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: isHRView ? '-3em' : '',
          marginLeft: '-1em',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F5F5FA',
            width: '100%',
            height: 'auto',

            marginRight: i18n?.language == 'ar' ? '6em' : '',
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                display: 'flex',
                padding: '20px',
                flexWrap: 'wrap',
              }}
            >
              <Box>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      width: '92vw',
                      marginTop: '1.75em',
                      padding: '1em',
                    }}
                  >
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '1em',
                        paddingBottom: '1em',
                        paddingLeft: '1em',
                        paddingRight: '1em',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.header,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Suggestions')}
                      </Typography>
                    </Box>
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                        paddingTop: '1em',
                        paddingBottom: '1em',
                        paddingLeft: '1em',
                        paddingRight: '1em',
                        marginTop: '1em',
                      }}
                    >
                      <Grid
                        container
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexWrap: 'nowrap',
                          marginTop: '1em',
                          marginBottom: '1em',
                          marginLeft: '0.1em',
                          marginRight: '3em',
                        }}
                        spacing={2}
                      >
                        <SearchComponent
                          onChange={(e: any) => setDebounceTerm(e)}
                          padding={'10px'}
                          width={'15%'}
                        />
                        <CustomAddButton
                          btnLabel={trans('Add Suggestions')}
                          onClick={() => closeModal(true)}
                        />
                      </Grid>
                      <Grid>
                        <Grid item>
                          <Box
                            className="ar_table"
                            sx={{
                              '& .header': {
                                backgroundColor: '#F5F5F5',
                              },

                              width: '100%',
                              overflowY: 'auto',
                            }}
                          >
                            <DataGrid
                              sx={{
                                color: '#081735',
                                font: 'normal normal normal 14px/24px Lato;',
                              }}
                              localeText={isRTL ? arabicDataGrid : undefined}
                              disableExtendRowFullWidth
                              disableSelectionOnClick
                              disableColumnMenu
                              autoHeight
                              disableColumnFilter
                              rows={row_data}
                              columns={tableColumns}
                              rowCount={totalCount}
                              pageSize={rowPerPage}
                              page={page}
                              paginationMode="server"
                              onPageChange={(newPage) =>
                                handlePageChange(newPage)
                              }
                              onPageSizeChange={(newPageSize) =>
                                handleRowsPerPageChange(newPageSize)
                              }
                              rowsPerPageOptions={[10, 25, 50, 100]}
                              componentsProps={{
                                pagination: {
                                  labelRowsPerPage: trans('Rows per page'),
                                },
                              }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <CustomModal
        isModalOpen={openModel}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="450px"
      >
        <ModalHeader
          modal={{ modal_title: trans('Add Suggestion') }}
          closeModal={() => closeModal(false)}
        />
        <Compdirection>
          <Grid
            container
            spacing={2}
            style={{
              marginTop: '5px',
            }}
          >
            <Grid item xs={12}>
              <Box
                style={{
                  height: 'auto',
                  border: '1px solid #0000001F',
                  borderRadius: '15px',
                  padding: '20px',
                  overflowY: 'auto',
                }}
              >
                <Grid container>
                  {suggestionEmpList?.length > 1 && (
                    <Grid item xs={12}>
                      <CustomAutoComplete
                        label={trans('Employee List')}
                        value={toEmpId}
                        options={_.map(suggestionEmpList, (emp: any) => ({
                          id: emp.empid,
                          label: emp.empname,
                        }))}
                        onChange={(event: any, newValue: any) => {
                          handleEmplist(newValue);
                        }}
                      />
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <CustomTextField
                      type="string"
                      label={trans('Title')}
                      placeholder={trans('Write Title')}
                      value={title}
                      onChange={(e: any) => setTitle(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <CustomTextField
                      type="string"
                      multiline={true}
                      label={trans('Description')}
                      placeholder={trans('Write Description')}
                      value={description}
                      onChange={(e: any) => setDescription(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <DropAndSelect
                      upload={suggestionAttachmentUpload}
                      src={suggestionAttachmentFilePath}
                      isPDF={isPDF}
                      pdfName={pdfName}
                      onDelete={() => {
                        setIsPDF(false);
                        setPDFName('');
                        setSuggestionAttachmentFilePath('');
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginTop: '35px' }} />
        </Compdirection>
        <ModalFooter
          onClickSubmit={handleSubmit}
          onClickCancel={() => closeModal(false)}
        />
      </CustomModal>
      <CustomModal
        isModalOpen={openEditModel}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="450px"
      >
        <ModalHeader
          modal={{ modal_title: trans('Edit Suggestion') }}
          closeModal={() => closeEditModal(false)}
        />
        <Compdirection>
          <Grid
            container
            spacing={2}
            style={{
              marginTop: '5px',
            }}
          >
            <Grid item xs={12}>
              <Box
                style={{
                  height: 'auto',
                  border: '1px solid #0000001F',
                  borderRadius: '15px',
                  padding: '20px',
                  overflowY: 'auto',
                }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <CustomAutoComplete
                      label={trans('Employee List')}
                      value={toEmpId}
                      options={_.map(suggestionEmpList, (emp: any) => {
                        return emp.empname;
                      })}
                      onChange={(event: any, newValue: any) => {
                        handleEmplist(newValue);
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <CustomTextField
                      type="string"
                      label={trans('Title')}
                      placeholder={trans('Write Title')}
                      value={title}
                      onChange={(e: any) => setTitle(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: '1em',
                      marginBottom: '1em',
                    }}
                  >
                    <CustomTextField
                      type="string"
                      multiline={true}
                      label={trans('Description')}
                      placeholder={trans('Write Description')}
                      value={description}
                      onChange={(e: any) => setDescription(e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xs={8}>
                    <DropAndSelect
                      upload={suggestionAttachmentUpload}
                      src={suggestionAttachmentFilePath}
                      isPDF={isPDF}
                      pdfName={pdfName}
                      onDelete={() => {
                        setIsPDF(false);
                        setPDFName('');
                        setSuggestionAttachmentFilePath('');
                      }}
                    />
                  </Grid> */}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginTop: '35px' }} />
        </Compdirection>
        <ModalFooter
          onClickSubmit={handleupdate}
          onClickCancel={() => closeEditModal(false)}
        />
      </CustomModal>
      <CustomModal
        isModalOpen={openStepper}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="800px"
      >
        <ModalHeader
          modal={{ modal_title: trans('Suggestion') }}
          closeModal={() => closeStepper(false)}
        />
        <Box className="border-box">
          {/* <Box
            style={{
              height: 'auto',
              border: '1px solid #0000001F',
              borderRadius: '15px',
              padding: '20px',
              overflowY: 'auto',
            }}
          > */}
          {/*  <CustomStepper_sugg suggstatusdata={sugg_status} /> */}
          <DataGrid
            sx={{
              color: '#081735',
              font: 'normal normal normal 14px/24px Lato;',
            }}
            localeText={isRTL ? arabicDataGrid : undefined}
            disableExtendRowFullWidth
            disableSelectionOnClick
            disableColumnMenu
            autoHeight
            disableColumnFilter
            rows={row_data_model}
            columns={tableColumns_model}
            //rowCount={totalCount}
            //pageSize={rowPerPage}
            page={page}
            paginationMode="server"
            onPageChange={(newPage) => handlePageChange(newPage)}
            onPageSizeChange={(newPageSize) =>
              handleRowsPerPageChange(newPageSize)
            }
            rowsPerPageOptions={[10, 25, 50, 100]}
            componentsProps={{
              pagination: {
                labelRowsPerPage: trans('Rows per page'),
              },
            }}
          />
          {/* </Box> */}
        </Box>
      </CustomModal>

      <CustomModal
        isModalOpen={openViewFullPicModal}
        overflowY="auto"
        modalHeight="630px"
        modalWidth="450px"
      >
        <ModalHeader
          modal={{ modal_title: trans('View Attachment') }}
          closeModal={() => setOpenViewFullPicModal(false)}
        />
        <ImageModelView
          url={attachmentUrl}
          isOpen={openViewFullPicModal}
          onClose={() => setOpenViewFullPicModal(false)}
          isAttachmentSigned={true}
        />
      </CustomModal>
    </Grid>
  );
};

export default SuggestionPresenter;
